// extracted by mini-css-extract-plugin
export default {"InputIcon":"SelectInput_InputIcon__LKDAN","labelMargin":"SelectInput_labelMargin__xnNs3","InputStyle":"SelectInput_InputStyle__DlS4D"};